import React, { useEffect, useState } from "react";
import { Text } from "@bookingcom/bui-react";
import styles from "./BlackFridayCountdown.module.css";
import { useI18n, t } from "@bookingcom/lingojs-react";

const BLACK_FRIDAY_END_DATE = "2025-12-04T23:59:59Z";

const BlackFridayCountdown: React.FC = () => {
  const [daysRemaining, setDaysRemaining] = useState<number | null>(null);
  const i18n = useI18n();
  useEffect(() => {
    const now = new Date();
    const end = new Date(BLACK_FRIDAY_END_DATE);
    const diffInMs = end.getTime() - now.getTime();
    const days = Math.floor(diffInMs / (1000 * 60 * 60 * 24));

    setDaysRemaining(days === 0 ? 1 : days);
  }, []);

  if (daysRemaining === null) {
    return null;
  }

  return (
    <Text variant="featured_3" color="brand_genius_secondary" className={styles.countdown}>
      {i18n.trans(
        t("deals_blackfriday25_www_index_hero_variable_countdown_banner", {
          variables: { num_days: daysRemaining },
          num_exception: daysRemaining
        })
      )}
    </Text>
  );
};

export default BlackFridayCountdown;
